<template>
  <v-card>
    <v-card-text>
      <v-radio-group
            v-model="editItem.printFormat"
            row
            mandatory
          >
      <v-row dense>
        <v-col cols="3">
          Estimate of Needs Print Size :
        </v-col>
        <v-col cols="2" dense>
          <v-radio
          class="input-text-size radio-and-checekbox-size"
          label="Letter"
          value="LETTER">
          </v-radio>
        </v-col>
        <v-col cols="2" dense>
          <v-radio
          class="input-text-size radio-and-checekbox-size"
          label="Legal"
          value="LEGAL">
          </v-radio>
        </v-col>
      </v-row>
      </v-radio-group>
       <v-row>
        <v-col cols="3" class="mt-1">
          Bank Account for MICR Line
        </v-col>
        <v-col cols="3">
          <v-select class="input-text-size "
          :items="banksList"
          item-text="bankName"
          item-value="_id"
          dense
          v-model="editItem.MICRbankName"
        ></v-select>
      </v-col>
        <v-col cols="3" class="mt-1">
          Section A Font Size
        </v-col>
        <v-col cols="3">
          <v-select class="input-text-size "
          :items="sectionAFontSizeOptions"
          item-text="text"
          item-value="value"
          dense
          v-model="editItem.sectionAFontSizeOverride"
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.treasurerPrintsWarrants"
            label="Treasurer Prints Warrants"
          ></v-checkbox>
        </v-col>
         <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.notRequireSourceNo"
            label="Do Not Require Source Code"
          ></v-checkbox>
        </v-col>
         <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.skipMtgTaxCertFee"
            label="Skip Mtg tax cert Fee"
          ></v-checkbox>
        </v-col>
               <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.PrintmicrOnRemit"
            label="Print MICR Line on Remit warrants"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size mt-n3"
            v-model="editItem.twoSignatureLines"
            label="Print Two Signature Lines"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size mt-n3"
            v-model="editItem.printFullWarrantNumberInMICR"
            label="Print full warrant number in MICR as displayed on remit Warrant"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size mt-n3"
            v-model="editItem.tenDigitCheckNumber"
            label="10 digit check number"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size mt-n3"
            v-model="editItem.removeTreasurerNameEONReport"
            label="Remove Treasurer name from from EON Report"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size mt-n3"
            v-model="editItem.apportionmentBasedOnUnitFund"
            label="Apportionment Based on Unit Fund"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size mt-n3"
            v-model="editItem.removeMicrLineFromCopyOfWarrants"
            label="Remove MICR Line from Copy of Remit Warrants"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size mt-n3"
            v-model="editItem.allowExceptionsOnSpecialUnitCodeMiscReceipts"
            label="Allow Exceptions on Special Unit Code Misc Receipts"
          ></v-checkbox>
        </v-col>
      </v-row>
      <!-- Left column keeps the non-ACH settings; the ACH box sits alongside it
           on the right, matching the client mock-up. -->
      <v-row>
        <v-col cols="6">
          <v-row>
            <v-col cols="8">
              <v-checkbox
                class="input-text-size radio-and-checekbox-size mt-n3"
                v-model="editItem.allowUnitCodeOnAPageItems"
                label="Allow Unit Codes on A Page Items"
                color="primary"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-checkbox
                class="input-text-size radio-and-checekbox-size mt-n3"
                v-model="editItem.addFunctionColumnToApportionmentAppropriations"
                label="Add Function Column to Apportionment Appropriations"
                color="primary"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0 pb-0">
              <label class="input-text-size">Remit Email Settings:</label>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="">
              <label class="input-text-size font-weight-light">Subject: </label>
            </v-col>
            <v-col cols="7" class="mt-n3">
              <v-text-field class="input-text-size pa-0" v-model="editItem.emailSubject"
               label="Subject" required />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="">
              <label class="input-text-size font-weight-light">CC Email Address: </label>
            </v-col>
            <v-col cols="7" class="mt-n3">
              <v-text-field class="input-text-size pa-0" v-model="editItem.emailCCAddress"
               label="CC Email Address" required />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="">
              <label class="input-text-size font-weight-light">Body: </label>
            </v-col>
            <v-col cols="7" class="mt-n3">
              <v-textarea class="input-text-size pa-0" outlined v-model="editItem.emailBody"
               label="Body" required />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-card id="achFileSettingsCard" outlined class="pa-3 text--secondary">
            <v-row dense>
              <v-col cols="12" class="text-center pt-0 pb-2">
                <label class="input-text-size font-weight-bold">ACH FILE SETTINGS</label>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="5" class="input-text-size py-1 mt-1">
                Bank Account for ACH
              </v-col>
              <v-col cols="7" class="py-1">
                <v-select class="input-text-size "
                :items="banksList"
                item-text="bankName"
                item-value="_id"
                dense
                hide-details
                v-model="editItem.bankName"
              ></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="7" offset="5" class="py-1">
                <v-text-field class="input-text-size pa-0" v-model="editItem.alternateBankName"
                 label="Alternate Name for ACH file" hide-details required />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="5" class="py-1">
                <v-checkbox
                  class="input-text-size radio-and-checekbox-size"
                  v-model="editItem.routingNumberInACH"
                  label="Routing Number in ACH"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="7" class="py-1">
                <v-checkbox
                  class="input-text-size radio-and-checekbox-size"
                  v-model="editItem.skipTotalPaymentLine"
                  label="Skip Total Payment row in ACH file"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-radio-group
              v-model="editItem.achSecCode"
              class="mt-0 text--secondary"
              row
              hide-details
            >
              <v-row dense>
                <v-col cols="5" class="input-text-size py-1 mt-1">
                  SEC Code
                </v-col>
                <v-col cols="3" class="py-1" dense>
                  <v-radio
                  class="input-text-size radio-and-checekbox-size"
                  label="PPD"
                  value="PPD">
                  </v-radio>
                </v-col>
                <v-col cols="4" class="py-1" dense>
                  <v-radio
                  class="input-text-size radio-and-checekbox-size"
                  label="CCD"
                  value="CCD">
                  </v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-row dense align="center" class="mt-2">
              <v-col cols="5" class="input-text-size py-1">
                Alternate Company Name
              </v-col>
              <v-col cols="7" class="py-1">
                <v-text-field id="achCompanyNameField" class="input-text-size pa-0"
                 v-model="editItem.achCompanyName" maxlength="16" hide-details />
              </v-col>
            </v-row>
            <v-row dense align="center">
              <v-col cols="5" class="input-text-size py-1">
                Destination Routing #
              </v-col>
              <v-col cols="7" class="py-1">
                <v-text-field id="immediateDestinationField" class="input-text-size pa-0"
                 v-model="editItem.immediateDestination" maxlength="10" hide-details />
              </v-col>
            </v-row>
            <v-row dense align="center">
              <v-col cols="5" class="input-text-size py-1">
                Destination Name
              </v-col>
              <v-col cols="7" class="py-1">
                <v-text-field id="immediateDestinationNameField" class="input-text-size pa-0"
                 v-model="editItem.immediateDestinationName" maxlength="23" hide-details />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="primary"
          @click="update"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { cloneItem } from '../../util/shared/vue-global';
import '../../assets/style.css';

export default {
  components: {
  },
  data: () => ({
    banksList: [],
    isSelectedBank: false,
    originalApportionmentSetting: null,
    // Auto-select (null) keeps the backend's row/amount-width auto-scaling; the
    // rest match the auto-scaling's own range (BASE_FONT_SIZE 7 up to the 1.4x
    // legibility ceiling, in 0.5pt steps) so a county can only ever pick a size
    // the auto path could itself have produced.
    sectionAFontSizeOptions: [
      { text: 'Auto-select', value: null },
      { text: '7.0', value: 7 },
      { text: '7.5', value: 7.5 },
      { text: '8.0', value: 8 },
      { text: '8.5', value: 8.5 },
      { text: '9.0', value: 9 },
      { text: '9.5', value: 9.5 },
    ],
  }),
  async created() {
    await this.loadConfig({ requiredScope: 'apportionmentConfig' });
    if (!this.editItem.achSecCode) {
      // PPD is the ACH default the backend falls back to when nothing is configured
      this.$set(this.editItem, 'achSecCode', 'PPD');
    }
    this.originalApportionmentSetting = cloneItem(this.buildApportionmentConfigItem());
    this.loadList();
  },
  computed: {
    ...mapState({
      apportionmentSettingItem: (state) => state.SystemConfig.apportionmentSettingItem || {},
    }),
    editItem() {
      return this.apportionmentSettingItem;
    },
    bankList() {
      const bankObjs = this.banksList;
      return bankObjs;
    },
  },
  methods: {
    ...mapActions('SystemConfig', [
      'loadConfig', 'updateConfig',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    async loadBankList() {
      const bankList = await this.loadBanks({
        criteria: {},
        baseCrudKey: 'sharedBank',
      });
      return bankList;
    },
    async loadList() {
      const banks = await this.loadBankList();
      if (banks && banks.length > 0) {
        banks.sort((a, b) => {
          if (a.bankName < b.bankName) {
            return -1;
          }
          if (a.bankName > b.bankName) {
            return 1;
          }
          return 0;
        });
      }
      this.banksList = banks;
    },
    buildApportionmentConfigItem() {
      const settingItem = this.editItem;
      /* When you will update any new field in the apportionment setting,
        you need to add the field here. */
      return {
        id: settingItem.id,
        printFormat: settingItem.printFormat,
        bankName: settingItem.bankName,
        MICRbankName: settingItem.MICRbankName,
        sectionAFontSizeOverride: settingItem.sectionAFontSizeOverride,
        treasurerPrintsWarrants: settingItem.treasurerPrintsWarrants,
        notRequireSourceNo: settingItem.notRequireSourceNo,
        skipMtgTaxCertFee: settingItem.skipMtgTaxCertFee,
        PrintmicrOnRemit: settingItem.PrintmicrOnRemit,
        twoSignatureLines: settingItem.twoSignatureLines,
        printFullWarrantNumberInMICR: settingItem.printFullWarrantNumberInMICR,
        tenDigitCheckNumber: settingItem.tenDigitCheckNumber,
        routingNumberInACH: settingItem.routingNumberInACH,
        removeTreasurerNameEONReport: settingItem.removeTreasurerNameEONReport,
        apportionmentBasedOnUnitFund: settingItem.apportionmentBasedOnUnitFund,
        removeMicrLineFromCopyOfWarrants: settingItem.removeMicrLineFromCopyOfWarrants,
        allowExceptionsOnSpecialUnitCodeMiscReceipts:
          settingItem.allowExceptionsOnSpecialUnitCodeMiscReceipts,
        allowUnitCodeOnAPageItems: settingItem.allowUnitCodeOnAPageItems,
        addFunctionColumnToApportionmentAppropriations:
          settingItem.addFunctionColumnToApportionmentAppropriations,
        emailSubject: settingItem.emailSubject,
        emailCCAddress: settingItem.emailCCAddress,
        emailBody: settingItem.emailBody,
        alternateBankName: settingItem.alternateBankName,
        skipTotalPaymentLine: settingItem.skipTotalPaymentLine,
        achSecCode: settingItem.achSecCode,
        achCompanyName: settingItem.achCompanyName,
        immediateDestination: settingItem.immediateDestination,
        immediateDestinationName: settingItem.immediateDestinationName,
      };
    },
    async update() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'apportionmentConfig',
          item: this.buildApportionmentConfigItem(),
          previousItem: this.originalApportionmentSetting,
          isLogAudit: true,
        };
        const ok = await this.updateConfig(payload);
        if (ok) {
          this.originalApportionmentSetting = cloneItem(this.buildApportionmentConfigItem());
        }
      }
    },
  },
};
</script>
